import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		r: 50,
		fill: "#006ADC"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M50.3416 72.8709L78.8624 34.1667C79.2164 33.7286 79.4779 33.2232 79.6311 32.6812C79.7842 32.1391 79.8259 31.5717 79.7536 31.0131C79.6813 30.4545 79.4964 29.9163 79.2102 29.4312C78.9241 28.946 78.5425 28.524 78.0886 28.1904C77.6347 27.8569 77.1179 27.6189 76.5694 27.4907C76.0209 27.3626 75.4521 27.347 74.8974 27.4449C74.3427 27.5427 73.8136 27.752 73.3421 28.0602C72.8706 28.3683 72.4665 28.7688 72.1541 29.2375L46.2083 64.45L29.2249 50.8625C28.3619 50.1719 27.2598 49.8523 26.1612 49.9742C25.0625 50.0961 24.0573 50.6495 23.3666 51.5125C22.6759 52.3756 22.3564 53.4777 22.4783 54.5763C22.5387 55.1203 22.7056 55.6471 22.9695 56.1266C23.2335 56.6061 23.5893 57.0289 24.0166 57.3709L44.3833 73.6542C44.824 73.9987 45.329 74.252 45.8687 74.3993C46.4084 74.5466 46.972 74.5849 47.5267 74.5119C48.0814 74.439 48.616 74.2563 49.0993 73.9746C49.5826 73.6928 50.0049 73.3176 50.3416 72.8709Z",
		fill: "#FBFBFB"
	})]
});
const ForwardRef = forwardRef(SvgSuccess);
export default ForwardRef;
